import { Toast, ToastContainer, Button } from "react-bootstrap";

const CustomToast = ({
  showToast,
  setShowToast,
  title,
  body,
  bgColor,
  actionType,
  onExtendSession,
  onCancelSession,
}) => {
  return (
    <ToastContainer position="top-center" className="p-3" style={{ zIndex: 5 }}>
      <Toast
        onClose={() => actionType !== "warning" && setShowToast(false)}
        show={showToast}
        delay={actionType === "warning" ? null : 3000}
        autohide={actionType !== "warning"}
        bg={bgColor}
      >
        <Toast.Header closeButton={actionType !== "warning"}>
          {actionType === "success" ? (
            <i className="bi bi-check-circle-fill text-success me-2"></i>
          ) : (
            <i className="bi bi-exclamation-triangle-fill text-danger me-2"></i>
          )}
          <strong className="me-auto">{title}</strong>
        </Toast.Header>
        <Toast.Body style={{ color: "white" }}>
          {body}
          {actionType === "warning" && (
            <div className="mt-2 d-flex justify-content-end">
              <Button
                variant="danger"
                size="sm"
                className="me-2"
                onClick={onCancelSession}
              >
                Cancel
              </Button>
              <Button variant="primary" size="sm" onClick={onExtendSession}>
                Extend
              </Button>
            </div>
          )}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default CustomToast;
